<template>
  <div class="wrap">
    <div class="search">
      <svg
        t="1639730657475"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2034"
        width="20"
        height="20"
      >
        <path
          d="M945.066667 898.133333l-189.866667-189.866666c55.466667-64 87.466667-149.333333 87.466667-241.066667 0-204.8-168.533333-373.333333-373.333334-373.333333S96 264.533333 96 469.333333 264.533333 842.666667 469.333333 842.666667c91.733333 0 174.933333-34.133333 241.066667-87.466667l189.866667 189.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c8.533333-12.8 8.533333-34.133333-2.133333-46.933334zM469.333333 778.666667C298.666667 778.666667 160 640 160 469.333333S298.666667 160 469.333333 160 778.666667 298.666667 778.666667 469.333333 640 778.666667 469.333333 778.666667z"
          p-id="2035"
        ></path>
      </svg>
      <input
        v-model="value"
        class="inp"
        type="text"
        placeholder="search"
        @input="getList"
      />
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item in area"
        :key="item.country_code"
        @click="onClick(item)"
      >
        <div>
          <div class="title">{{ item.enName }}</div>
          <div class="title">{{ item.selfName }}</div>
        </div>
        <div class="value">{{ `+${item.areaCode}` }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaNums } from "@/utils/area_nums";
export default {
  name: "SelectArea",
  data() {
    return {
      value: "",
      area: [],
      lang: this.$store.state.language,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.area = areaNums.filter(
        (item) =>
          item.selfName.includes(this.value) ||
          item.enName.toLowerCase().includes(this.value) ||
          item.areaCode.includes(this.value)
      );
    },
    onClick(item) {
      this.$emit("onChange", item.areaCode);
      this.value = "";
      this.getList();
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100vw;
  height: 80vh;
}
.search {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 8px solid #f2f2f2;
  padding: 5px;
}
.search .inp {
  flex: 1;
  padding-left: 10px;
  background-color: transparent;
  line-height: 25px;
  height: 25px;
}
.list {
  position: absolute;
  top: 51px;
  left: 0;
  width: 100%;
  bottom: 0;
  overflow-y: auto;
}
/deep/ .mint-cell-text {
  margin-left: 0;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #dedfdf;
}
.value {
  font-size: 15px;
  color: #888;
}
</style>
